import { ref } from 'vue'

const isVisible = ref(false)
const progress = ref(0)

let _ticker: ReturnType<typeof setInterval> | null = null
let _finishTimer: ReturnType<typeof setTimeout> | null = null

function _clearTimers() {
  if (_ticker) { clearInterval(_ticker); _ticker = null }
  if (_finishTimer) { clearTimeout(_finishTimer); _finishTimer = null }
}

function start() {
  _clearTimers()
  progress.value = 0
  isVisible.value = true

  _ticker = setInterval(() => {
    const increment = progress.value < 70
      ? 5 + Math.random() * 10
      : progress.value < 90
        ? 0.5 + Math.random() * 2
        : 0
    progress.value = Math.min(progress.value + increment, 90)
  }, 100)
}

function done() {
  _clearTimers()
  progress.value = 100

  _finishTimer = setTimeout(() => {
    isVisible.value = false
    progress.value = 0
  }, 400)
}

export function useNavProgress() {
  return { isVisible, progress, start, done }
}
